import { c as N, a as $ } from "./client-06a9gTq4.js";
import { gql as a } from "graphql-request";
const u = a`
  fragment EndCards on PublicEndCardType {
    id
    callToActionButton {
      id
      label
      icon
      url
    }
    promoCodeButton {
      id
      label
      text
    }
    watchNextButtonVisible
    socialMediaButtons {
      platformName
      accountUrl
      label
      id
    }
    cardType
    origin
    customCode
    background
    border
    id
    headline
    subline
    videoControlButtons
    cardSize
    backgroundImageUrl
    overlay
    cardOrientation
    backgroundImageSettings
    ctaButton1 {
      name
      id
      text
      url
      background
      border
      icon
    }
    ctaButton2 {
      name
      id
      text
      url
      background
      border
      icon
    }
  }
`, p = a`
  fragment PromotedContentFragment on VideoPromotedContentSettingsType {
    promoteObjects
    promoteAtStart
    promoteAtEnd
    promotedObjectsLabel
  }
`, g = a`
  ${p}
  ${u}

  query GetVideoById(
    $id: ID!
    $playerLocationUrl: URL
    $clipUrlMomentIdParam: String
  ) {
    publicVideoById(id: $id) {
      id
      duration
      slug
      structuredData(
        playerLocationUrl: $playerLocationUrl
        clipUrlMomentIdParam: $clipUrlMomentIdParam
      )
      thumbnailUrl
      title
      captions {
        language
        languageCode
        captionFileUrl
      }
      shareSocialMediaIcons {
        platformName
        visible
      }
      videoFileUrl
      videoStreams {
        standard
        manifestFileUrl
      }
      aspectRatio
      moments {
        id
        title
        duration
        startTimestamp
        endTimestamp
        thumbnailUrl
        endCard {
          ...EndCards
        }
      }
      promotedContentSettings {
        ...PromotedContentFragment
      }
      objects {
        title
        url
        promote
        id
        imageUrl
      }
      endCard {
        ...EndCards
      }
      monetization {
        orgMonetization {
          id
          active
          default
          monetizationUrl
          name
        }
        useDefaultMonetization
        isMonetizationEnabled
        adType
        adDensity
        adLocation
      }
      endCard {
        ...EndCards
      }
      orgLogoUrl
      orgLogoPosition
      orgLogoEnabled
      ctaTimestamps {
        id
        name
        startTimestamp
        endTimestamp
        ctas {
          id
          button {
            id
            name
            url
            text
            background
            border
            icon
          }
          image {
            id
            name
            url
            imageUrl
          }
          config
          order
        }
      }
    }
  }
`;
function b(t) {
  const e = JSON.parse(t.config);
  return {
    id: t.id,
    order: t.order,
    config: e,
    href: t.image?.url ?? t.button?.url,
    imageUrl: t.image?.imageUrl,
    imageAlt: t.image?.name,
    buttonText: t.button?.text,
    buttonBackground: t.button?.background,
    buttonBorder: t.button?.border
  };
}
function r(t) {
  return {
    id: t.id,
    name: t.name,
    startTimestamp: t.startTimestamp,
    endTimestamp: t.endTimestamp,
    ctas: t.ctas.map(b)
  };
}
const m = (t) => ({
  id: t.id,
  name: t.name,
  url: t.url,
  text: JSON.parse(t.text),
  background: JSON.parse(t.background),
  border: JSON.parse(t.border),
  icon: JSON.parse(t.icon)
});
function o(t) {
  return {
    id: t.id,
    headline: t.headline ? JSON.parse(t.headline) ?? void 0 : void 0,
    subline: t.subline ? JSON.parse(t.subline) ?? void 0 : void 0,
    background: t.background ?? void 0,
    backgroundImageUrl: t.backgroundImageUrl ?? void 0,
    overlay: t.overlay ?? void 0,
    ctaButton1: t.ctaButton1 ? m(t.ctaButton1) : void 0,
    ctaButton2: t.ctaButton2 ? m(t.ctaButton2) : void 0
  };
}
function C(t) {
  return {
    id: t.id,
    title: t.title,
    startTimestamp: t.startTimestamp,
    endTimestamp: t.endTimestamp,
    duration: t.duration,
    thumbnailUrl: t.thumbnailUrl ?? void 0,
    endCard: t.endCard ? o(t.endCard) : void 0
  };
}
function T(t) {
  const e = t.videoStreams?.find((i) => i.standard) ?? t.videoStreams?.[0];
  let n;
  if (t.structuredData)
    try {
      n = JSON.parse(t.structuredData);
    } catch {
    }
  return {
    id: t.id,
    title: t.title,
    src: e?.manifestFileUrl ?? t.videoFileUrl ?? "",
    poster: t.thumbnailUrl,
    duration: t.duration,
    captions: t.captions,
    ctaTimestamps: t.ctaTimestamps?.map(r),
    endCard: t.endCard ? o(t.endCard) : void 0,
    shareSocialMediaIcons: t.shareSocialMediaIcons,
    moments: t.moments?.map(C),
    structuredData: n
  };
}
async function f(t, e) {
  const n = await t.request(g, {
    id: e
  });
  return T(n.publicVideoById);
}
const U = a`
  fragment EndCards on PublicEndCardType {
    id
    callToActionButton {
      id
      label
      icon
      url
    }
    promoCodeButton {
      id
      label
      text
    }
    watchNextButtonVisible
    socialMediaButtons {
      platformName
      accountUrl
      label
      id
    }
    cardType
    origin
    customCode
    background
    border
    id
    headline
    subline
    videoControlButtons
    cardSize
    backgroundImageUrl
    overlay
    cardOrientation
    backgroundImageSettings
    ctaButton1 {
      name
      id
      text
      url
      background
      border
      icon
    }
    ctaButton2 {
      name
      id
      text
      url
      background
      border
      icon
    }
  }
`, y = a`
  fragment PromotedContentFragment on VideoPromotedContentSettingsType {
    promoteObjects
    promoteAtStart
    promoteAtEnd
    promotedObjectsLabel
  }
`, I = a`
  fragment PlaylistItem on PlaylistItem {
    ... on PublicVideoType {
      __typename
      id
      duration
      slug
      structuredData
      thumbnailUrl
      title
      captions {
        language
        languageCode
        captionFileUrl
      }
      videoFileUrl
      videoStreams {
        standard
        manifestFileUrl
      }
      aspectRatio
      endCard {
        ...EndCards
      }
      promotedContentSettings {
        ...PromotedContentFragment
      }
      objects {
        title
        url
        promote
        id
        imageUrl
      }
      moments {
        id
        title
        duration
        startTimestamp
        endTimestamp
        thumbnailUrl
        endCard {
          ...EndCards
        }
      }
      monetization {
        orgMonetization {
          id
          active
          default
          monetizationUrl
          name
        }
        useDefaultMonetization
        isMonetizationEnabled
        adType
        adDensity
        adLocation
      }
      ctaTimestamps {
        id
        name
        startTimestamp
        endTimestamp
        ctas {
          id
          button {
            id
            name
            url
            text
            background
            border
            icon
          }
          image {
            id
            name
            url
            imageUrl
          }
          config
          order
        }
      }
    }
    ... on PublicMomentType {
      __typename
      id
      startTimestamp
      endTimestamp
      duration
      slug
      structuredData
      thumbnailUrl
      title
      endCard {
        ...EndCards
      }
      video {
        id
        duration
        title
        slug
        thumbnailUrl
        captions {
          language
          languageCode
          captionFileUrl
        }
        aspectRatio
        videoFileUrl
        videoStreams {
          standard
          manifestFileUrl
        }
        promotedContentSettings {
          ...PromotedContentFragment
        }
        objects {
          id
          title
          category
          url
          imageUrl
          promote
        }
        monetization {
          orgMonetization {
            id
            active
            default
            monetizationUrl
            name
          }
          useDefaultMonetization
          isMonetizationEnabled
          adType
          adDensity
          adLocation
        }
        ctaTimestamps {
          id
          name
          startTimestamp
          endTimestamp
          ctas {
            id
            button {
              id
              name
              url
              text
              background
              border
              icon
            }
            image {
              id
              name
              url
              imageUrl
            }
            config
            order
          }
        }
      }
    }
  }
`, v = a`
  ${y}
  ${U}
  ${I}

  query GetPlaylistById(
    $playlistId: ID!
    $playerLocationUrl: URL!
    $page: Int
    $pageSize: Int
    $listItemUrlItemIdParam: String
  ) {
    publicPlaylistById(id: $playlistId) {
      id
      name
      items(page: $page, pageSize: $pageSize) {
        totalCount
        pageInfo {
          hasNextPage
        }
        nodes {
          ...PlaylistItem
        }
      }
      contentType
      structuredData(
        playerLocationUrl: $playerLocationUrl
        listItemUrlItemIdParam: $listItemUrlItemIdParam
      )
    }
  }
`;
function S(t) {
  return t.__typename === "PublicVideoType" ? {
    ...t,
    endCard: t.endCard ? o(t.endCard) : void 0,
    ctaTimestamps: t.ctaTimestamps?.map(r),
    moments: t.moments.map((e) => ({
      ...e,
      endCard: e.endCard ? o(e.endCard) : void 0
    }))
  } : {
    ...t,
    endCard: t.endCard ? o(t.endCard) : void 0,
    video: {
      ...t.video,
      ctaTimestamps: t.video.ctaTimestamps?.map(r)
    }
  };
}
async function B(t, e, n) {
  const { playerLocationUrl: i, page: l, pageSize: s, listItemUrlItemIdParam: c } = n, d = (await t.request(v, {
    playlistId: e,
    playerLocationUrl: i,
    page: l,
    pageSize: s,
    listItemUrlItemIdParam: c
  })).publicPlaylistById;
  return d ? {
    ...d,
    items: {
      ...d.items,
      nodes: d.items.nodes?.map(S) ?? null
    }
  } : null;
}
export {
  N as createClient,
  $ as createPublicClient,
  B as getPlaylist,
  f as getVideo
};
